import { render, staticRenderFns } from "./FeedbackPoptip.vue?vue&type=template&id=46adb3f8&scoped=true&"
import script from "./FeedbackPoptip.vue?vue&type=script&lang=js&"
export * from "./FeedbackPoptip.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPoptip.vue?vue&type=style&index=0&id=46adb3f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46adb3f8",
  null
  
)

export default component.exports